import React from "react";

import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { MainContentWrapper, Row } from "components/Layout";
import NoUserRoleDisplay from "components/NoUserRoleDisplay";
import RolePicker from "components/RolePicker";

import { getActiveRole } from "selectors";

const NoRoleWrapper = styled.div`
  margin: ${({ theme }) => theme.space[3]}px;
  background-color: ${({ theme }) => theme.colors.gray95};
  @media (max-width: ${({ theme }) => theme.breakpoints[0]}px) {
    margin: 0;
  }
`;

function UserOverview() {
  const activeRole = useSelector(getActiveRole);
  const userHasNoRoles = activeRole.slug === null;
  const Wrapper = userHasNoRoles ? NoRoleWrapper : MainContentWrapper;
  return (
    <Wrapper>
      <Row>
        <RolePicker embedded />
      </Row>
      {userHasNoRoles && <NoUserRoleDisplay />}
    </Wrapper>
  );
}

export default UserOverview;
